var config = {
    api: {
        host: process.env.API_URL
    },
    widget: {
        timeSessionWdSummary: process.env.TIME_SESSION_WIDGET_SUMMARY || 900000
    },
    global: {
        globalUpdateInterval: process.env.GLOBAL_UPDATE_INTERVAL || 30000
    }
};
var API_HOST = config.api.host;
var TIME_SESSION_WIDGET_SUMMARY = config.widget.timeSessionWdSummary;
var GLOBAL_UPDATE_INTERVAL = config.global.globalUpdateInterval;
export { API_HOST, TIME_SESSION_WIDGET_SUMMARY, GLOBAL_UPDATE_INTERVAL };
export default config;
